import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const AdditionalFilterFormField = iotsUtils.fromList(
	constants.job.dashboard.additionalFilterFormFields
);

export const FilterFormField = iotsUtils.fromList(constants.job.dashboard.filterFormFields);
